import { FormLabel } from '@dnb/eufemia';
import { Field, Form, Wizard } from '@dnb/eufemia/extensions/forms';
import { ApiDto, SeverityClassification } from '@portals/shared/portal/ApiDto';

import { Purpose, SubscriberSubType, SubscriberType } from './constants';

type EditScopesProps = {
  api: ApiDto;
};

export default function AdditionalInfo({ api }: EditScopesProps) {
  return (
    <Form.Card>
      <Field.Selection
        label="Subscriber type"
        path="/serviceNowMetaData/subscriberType"
        placeholder="Please select a value"
      >
        {Object.entries(SubscriberType).map(([key, value]) => (
          <Field.Option key={key} value={key}>
            {value}
          </Field.Option>
        ))}
      </Field.Selection>
      <Form.Visibility
        animate
        compensateForGap="auto" // makes animation smooth
        visibleWhen={{
          path: '/serviceNowMetaData/subscriberType',
          hasValue: 'data',
        }}
      >
        <Field.Selection
          defaultValue={Object.entries(SubscriberSubType)[0]![0]} // Default to the first value
          label="Subscriber sub type"
          path="/serviceNowMetaData/subscriberSubType"
          placeholder="Please select a value"
        >
          {Object.entries(SubscriberSubType).map(([key, value]) => (
            <Field.Option key={key} value={key}>
              {value}
            </Field.Option>
          ))}
        </Field.Selection>
      </Form.Visibility>

      {api.severityClassification === SeverityClassification.STRICTLY_CONFIDENTIAL && (
        <>
          <FormLabel>
            This API is exposing personal identifiable information (PII), please specify how it should be handled.
          </FormLabel>
          <Field.Boolean
            label="Only persons with specific roles"
            onChangeValidator={async () => {}}
            path="/serviceNowMetaData/onlyPersonsWithSpecificRoles"
            top="small"
          />
          <Field.Boolean
            label="Data will be encrypted on field level"
            onChangeValidator={async () => {}}
            path="/serviceNowMetaData/dataWillBeEncryptedOnFieldLevel"
            top="small"
          />
          <Field.Boolean
            label="Data will be encrypted on table level"
            onChangeValidator={async () => {}}
            path="/serviceNowMetaData/dataWillBeEncryptedOnTableLevel"
            top="small"
          />
          <Field.Boolean
            label="Data will be encrypted in transit"
            onChangeValidator={async () => {}}
            path="/serviceNowMetaData/dataWillBeEncryptedInTransit"
            top="small"
          />
        </>
      )}
      {api.piiExposed && (
        <Field.Selection
          defaultValue={Object.entries(Purpose)[0]![0]}
          label="Purpose for receiving PII data"
          path="/serviceNowMetaData/purpose"
          placeholder="Please select a value"
        >
          {Object.entries(Purpose).map(([key, value]) => (
            <Field.Option key={key} value={key}>
              {value}
            </Field.Option>
          ))}
        </Field.Selection>
      )}

      <Field.String
        label="Use case"
        multiline
        path="/useCase"
        placeholder="Please provide some information of how you are going to use the API"
        rows={5}
        width="stretch"
      />
      <Wizard.Buttons />
    </Form.Card>
  );
}
